import React from 'react';
import { ClipboardCheckIcon } from '@heroicons/react/outline';

const Sidebar = ({ 
  courseData, 
  currentLesson, 
  openSections, 
  toggleSection, 
  handleLessonSelect, 
  isSidebarOpen,
  setIsSidebarOpen,
  courseId
}) => {
  return (
    <>
      {/* Toggle Button - Fixed at bottom right */}
      <button
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        className="fixed bottom-4 right-4 z-50 p-3 bg-white dark:bg-gray-800 rounded-full shadow-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-300 ease-in-out"
        style={{ transform: isSidebarOpen ? 'translateX(-320px)' : 'translateX(0)' }}
      >
        <svg className="w-6 h-6 text-gray-600 dark:text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
        </svg>
      </button>

      {/* Sidebar */}
      <div className={`fixed top-16 bottom-0 right-0 w-80 bg-white dark:bg-gray-800 border-l border-r border-b border-gray-300 dark:border-gray-700 transform transition-transform duration-300 ease-in-out overflow-y-auto
        ${isSidebarOpen ? 'translate-x-0' : 'translate-x-full'}`}
      >
        {/* Course Info */}
        <div className="p-4 border-b border-gray-300 dark:border-gray-700">
          <h2 className="text-gray-900 dark:text-white font-medium text-center">المحتوى</h2>
        </div>

        {/* Course Content */}
        <div className="p-4">
          {courseData.sections.map((section) => (
            <div key={section.id} className="mb-2">
              <button
                onClick={() => toggleSection(section.id)}
                className="w-full flex items-center justify-between p-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg text-gray-900 dark:text-white hover:bg-gray-50 dark:hover:bg-gray-700"
              >
                <span className="font-medium">{section.title}</span>
                <svg
                  className={`w-5 h-5 transition-transform ${openSections.includes(section.id) ? 'transform rotate-180' : ''}`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {/* محتوى القسم */}
              {openSections.includes(section.id) && (
                <div className="mt-1 pr-2">
                  
                  
                  {/* عرض المحتوى المرتب باستخدام مصفوفة items */}
                  {section.items && section.items.map((item) => {
                    // التحقق من صلاحيات المستخدم
                    const userPermissions = sessionStorage.getItem('userPermissions');
                    const hasViewAllCoursesPermission = userPermissions ? JSON.parse(userPermissions).includes('view_all_courses') : false;
                    
                    // إذا كان المستخدم مدير، نعرض كل المحتوى
                    if (hasViewAllCoursesPermission) {
                      // نعرض كل المحتوى للمدير
                    } 
                    // إذا كان المحتوى مجاني، نعرضه للجميع
                    else if (item.is_free === true || item.is_free === 1 || item.is_free === '1') {
                      // نعرض المحتوى المجاني
                    }
                    // إذا كان المحتوى مدفوع، نتأكد من أن المستخدم مشتري الدورة
                    else {
                      // نستخدم sessionStorage للتحقق من حالة الشراء (سيتم تحديثها عند فتح الصفحة)
                      const purchasedCourses = JSON.parse(sessionStorage.getItem('purchasedCourses') || '[]');
                      const hasPurchased = purchasedCourses.includes(parseInt(courseId));
                      
                      // إذا لم يكن المشتري، لا نعرض المحتوى المدفوع
                      if (!hasPurchased) {
                        return null;
                      }
                    }
                    // تحديد نوع الأيقونة حسب نوع المحتوى
                    let icon;
                    switch (item.type) {
                      case 'lesson':
                        icon = (
                          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                        );
                        break;
                      case 'quiz':
                        icon = <ClipboardCheckIcon className="w-4 h-4" />;
                        break;
                      case 'resource':
                        icon = (
                          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                          </svg>
                        );
                        break;
                      case 'group':
                        icon = (
                          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
                          </svg>
                        );
                        break;
                      default:
                        icon = <span className="w-4 h-4"></span>;
                    }

                    return (
                      <button
                        key={item.id}
                        onClick={() => handleLessonSelect(item)}
                        className={`w-full flex items-center justify-between p-2 rounded-lg text-sm
                          ${(currentLesson && currentLesson.id === item.id && (
                              (currentLesson.type && item.type && currentLesson.type === item.type) ||
                              (!item.type && !currentLesson.type)
                            ))
                            ? 'bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white'
                            : 'text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700/70 hover:text-gray-900 dark:hover:text-white'
                          }`}
                      >
                        <div className="flex items-center gap-2">
                          {icon}
                          <span>{item.title}</span>
                        </div>
                        {item.duration && (
                          <span className="text-xs">
                            {item.duration} {typeof item.duration === 'number' || !isNaN(parseInt(item.duration)) ? 
                              (parseInt(item.duration) === 1 ? 'دقيقة' : 
                               parseInt(item.duration) === 2 ? 'دقيقتان' : 
                               parseInt(item.duration) >= 3 && parseInt(item.duration) <= 10 ? 'دقائق' : 'دقيقة') : ''}
                          </span>
                        )}
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Sidebar;